// src/services/notificationService.ts
import api from './api';
import { Notification, CreateNotificationPayload } from '../types/church';

const NOTIFICATION_ENDPOINTS = {
  create: '/notifications/',
  update: (id: number) => `/notifications/${id}/`,
  delete: (id: number) => `/notifications/${id}/`,
  bulk: '/notifications/bulk',
  notifyEventCreation: (eventId: number) => `/event-notifications/${eventId}/notify-creation`,
  createEventReminders: (eventId: number) => `/event-notifications/${eventId}/create-reminders`,
};

export interface BulkNotificationPayload {
  eglise_id: number;
  type: 'push' | 'sms' | 'email' | 'in_app';
  message: string;
  scheduled_at?: string;
}

export const createNotification = async (payload: CreateNotificationPayload): Promise<Notification> => {
  console.log('[NotificationService] Creating notification:', payload);
  const response = await api.post<Notification>(NOTIFICATION_ENDPOINTS.create, payload);
  console.log('[NotificationService] Notification created:', response.data);
  return response.data;
};

export const updateNotification = async (id: number, payload: Partial<CreateNotificationPayload>): Promise<Notification> => {
  console.log('[NotificationService] Updating notification:', id, payload);
  const response = await api.put<Notification>(NOTIFICATION_ENDPOINTS.update(id), payload);
  console.log('[NotificationService] Notification updated:', response.data);
  return response.data;
};

export const deleteNotification = async (id: number): Promise<void> => {
  console.log('[NotificationService] Deleting notification:', id);
  await api.delete(NOTIFICATION_ENDPOINTS.delete(id));
  console.log('[NotificationService] Notification deleted');
};

export const createBulkNotifications = async (payload: BulkNotificationPayload): Promise<{ count: number }> => {
  console.log('[NotificationService] Creating bulk notifications:', payload);
  const response = await api.post<{ count: number }>(NOTIFICATION_ENDPOINTS.bulk, payload);
  console.log('[NotificationService] Bulk notifications created:', response.data);
  return response.data;
};

export const notifyEventCreation = async (eventId: number): Promise<{ count: number }> => {
  console.log('[NotificationService] Notifying event creation:', eventId);
  const response = await api.post<{ count: number }>(NOTIFICATION_ENDPOINTS.notifyEventCreation(eventId));
  console.log('[NotificationService] Event creation notified:', response.data);
  return response.data;
};

export const createEventReminders = async (eventId: number): Promise<{ count: number }> => {
  console.log('[NotificationService] Creating event reminders:', eventId);
  const response = await api.post<{ count: number }>(NOTIFICATION_ENDPOINTS.createEventReminders(eventId));
  console.log('[NotificationService] Event reminders created:', response.data);
  return response.data;
};

export default {
  createNotification,
  updateNotification,
  deleteNotification,
  createBulkNotifications,
  notifyEventCreation,
  createEventReminders,
};
